import {FETCH_DOCTOR_DATA} from "./index" 

export const setDoctorData = (payload) => {
    return {
      type: FETCH_DOCTOR_DATA,
      payload: payload
    };
  };